var map = {
	"./de": [
		404,
		4
	],
	"./de.json": [
		404,
		4
	],
	"./dummy": [
		405,
		3
	],
	"./dummy.json": [
		405,
		3
	],
	"./en": [
		232
	],
	"./en.json": [
		232
	],
	"./es": [
		406,
		2
	],
	"./es.json": [
		406,
		2
	],
	"./fr": [
		407,
		1
	],
	"./fr.json": [
		407,
		1
	],
	"./ja": [
		408,
		0
	],
	"./ja.json": [
		408,
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 1036;


//////////////////
// WEBPACK FOOTER
// ./src/locales/bundles async ^\.\/.*$
// module id = 1036
// module chunks = 5